// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgHint = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color ?? 'currentColor'}
      d="M8 0C3.59 0 0 3.59 0 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8m0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6"
    />
    <path
      fill={props.color ?? 'currentColor'}
      d="M10.3 4.32c-.23-.23-.54-.43-.92-.58s-.85-.23-1.42-.23c-.44 0-.84.07-1.19.22-.36.15-.66.35-.91.62-.25.26-.45.58-.59.94s-.21.76-.22 1.19h1.76c0-.22.02-.42.07-.61s.12-.35.22-.49.23-.25.38-.34.34-.13.56-.13c.32 0 .57.09.75.26.18.18.27.45.27.82 0 .22-.03.4-.11.54s-.19.28-.33.4-.28.24-.44.36-.31.26-.46.43c-.14.16-.27.36-.38.59s-.17.52-.2.86v.54h1.62v-.46c.03-.24.11-.44.23-.6s.27-.3.43-.43.33-.25.51-.37a2.3 2.3 0 0 0 .86-1.09c.1-.25.15-.56.15-.95q0-.345-.15-.75a2.1 2.1 0 0 0-.5-.75zM8 12.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
  </svg>
)
export default SvgHint
